import {all, call, put, takeLatest} from '@redux-saga/core/effects';
import {PayloadAction} from '@reduxjs/toolkit';
import {
  INTERNSHIP_HISTORY,
  internshipHistorySearchError,
  internshipHistorySearchSuccess,
  evaluationMeetingsSearchSuccess,
  evaluationMeetingsSearchError,
  INTERN_DEGREE_POOLS,
  HISTORICAL_INTERNSHIP_LOCATIONS,
  COMPANY_HISTORICAL_INTERN_DEGREES,
  MATCHED_STUDENTS,
  UPCOMING_INTERN_LOCATIONS,
  UPCOMING_INTERN_DEGREES,
  INTERNS_LIST,
  LOCATION_INTERNS,
  SEASON_INTERNS,
  SUMMER_TO_SUMMER_RETENTION,
  ALL_SEASONS_INTERN_EXPERIENCE_TASK,
  ALL_SEASONS_QUESTIONS,
  LEARNING_CONTRACTS,
  INTERNSHIP_EXPERIENCE,
  EVALUATION_MEETINGS,
  summerToSummerRetentionSearchSuccess,
  summerToSummerRetentionSearchError,
  allSeasonsInternExperienceTaskSearchSuccess,
  allSeasonsInternExperienceTaskSearchError,
  allSeasonsQuestionsSearchSuccess,
  allSeasonsQuestionsSearchError,
  learningContractsSearchSuccess,
  learningContractsSearchError,
  internshipExperienceSearchError,
  upcomingInternDegreesSearchSuccess,
  internsListSearchSuccess,
  seasonInternsSearchSuccess,
  seasonInternsSearchError,
  locationInternsSearchSuccess,
  locationInternsSearchError,
  historicalInternshipLocationsSearchSuccess,
  companyHistoricalInternDegreesSearchSuccess,
  companyHistoricalInternDegreesSearchError,
  matchedStudentsSearchSuccess,
  upcomingInternLocationsSearchSuccess,
  upcomingInternLocationsSearchError,
  upcomingInternDegreesSearchError,
  internsListSearchError,
  internDegreePoolsSearchSuccess,
  internDegreePoolsSearchError,
  historicalInternshipLocationsSearchError,
  matchedStudentsSearchError, internshipExperienceSearchSuccess,
} from './Actions';
import authApi from '../../@template/services/auth/authApi/authenticatedApi';
import {apiConfig} from '../../config';
import {
  IInternshipHistoryRequest,
} from '../../types/requests/CompanyInternshipHistoryParamsModel';
import {CompanyInternshipSeasonDataModel} from '../../types/models/CompanyInternshipSeasonDataModel';
import {CompanyInternDegreePoolsDataModel} from '../../types/models/CompanyInternDegreePoolsDataModel';
import {IInternDegreePoolsRequest} from '../../types/requests/CompanyInternDegreePoolsParamsModel';
import {
  CompanyInternLocationsDataModel,
} from '../../types/models/CompanyInternLocationsDataModel';
import {CompanySummerRetentionDataModel} from '../../types/models/SummerRetentionDataModel';


export function* LoadInternshipHistory({ companyId, searchParams }: IInternshipHistoryRequest) {
  console.log('SAGA - companyInsightsSaga - LoadInternshipHistory');
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'POST',
      url: `${apiConfig.coreReportingPath}/companies/insights/internship-history/${companyId}`,
      data: searchParams
    });
    console.log(res.data);
    const data = res.data.map((x: any) => CompanyInternshipSeasonDataModel.fromJS(x));
    yield put(internshipHistorySearchSuccess(data));
  } catch (err) {
    yield put(internshipHistorySearchError(err));
  }
}

export function* LoadInternDegreePools({ companyId, searchParams }: IInternDegreePoolsRequest) {
  console.log('SAGA - companyInsightsSaga - LoadInternDegreePools');
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'POST',
      url: `${apiConfig.coreReportingPath}/companies/insights/intern-degree-pools/${companyId}`,
      data: searchParams
    });
    const data = res.data.map((x: any) => CompanyInternDegreePoolsDataModel.fromJS(x));
    yield put(internDegreePoolsSearchSuccess(data));
  } catch (err) {
    yield put(internDegreePoolsSearchError(err));
  }
}

export function* LoadHistoricalInternshipLocations(companyId: string) {
  console.log('SAGA - companyInsightsSaga - LoadHistoricalInternshipLocations');
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'GET',
      url: `${apiConfig.coreReportingPath}/companies/insights/historical-internship-locations/${companyId}`,
    });
    const data = res.data.map((x: any) => CompanyInternLocationsDataModel.fromJS(x));
    yield put(historicalInternshipLocationsSearchSuccess(data));
  } catch (err) {
    yield put(historicalInternshipLocationsSearchError(err));
  }
}

export function* LoadCompanyHistoricalInternDegrees(companyId: string) {
  console.log('SAGA - companyInsightsSaga - LoadCompanyHistoricalInternDegrees');
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'GET',
      url: `${apiConfig.coreReportingPath}/companies/insights/historical-internship-degree-pools/${companyId}`,
    });
    const data = res.data.map((x: any) => CompanyInternDegreePoolsDataModel.fromJS(x));
    yield put(companyHistoricalInternDegreesSearchSuccess(data));
  } catch (err) {
    yield put(companyHistoricalInternDegreesSearchError(err));
  }
}

export function* LoadMatchedStudents(companyId: string) {
  console.log('SAGA - companyInsightsSaga - LoadMatchedStudents');
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'GET',
      url: `${apiConfig.coreReportingPath}/companies/insights/students-matched-upcoming/${companyId}`,
    });
    const data = res.data.map((x: any) => CompanyInternshipSeasonDataModel.fromJS(x));
    yield put(matchedStudentsSearchSuccess(data));
  } catch (err) {
    yield put(matchedStudentsSearchError(err));
  }
}

export function* LoadUpcomingInternLocations(companyId: string) {
  console.log('SAGA - companyInsightsSaga - LoadUpcomingInternLocations');
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'GET',
      url: `${apiConfig.coreReportingPath}/companies/insights/upcoming-intern-locations/${companyId}`
    });
    const data = res.data.map((x: any) => CompanyInternLocationsDataModel.fromJS(x));
    yield put(upcomingInternLocationsSearchSuccess(data));
  } catch (err) {
    yield put(upcomingInternLocationsSearchError(err));
  }
}

export function* LoadUpcomingInternDegrees(companyId: string) {
  console.log('SAGA - companyInsightsSaga - LoadUpcomingInternDegrees');
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'GET',
      url: `${apiConfig.coreReportingPath}/companies/insights/upcoming-intern-degrees/${companyId}`
    });
    const data = res.data.map((x: any) => CompanyInternDegreePoolsDataModel.fromJS(x));
    yield put(upcomingInternDegreesSearchSuccess(data));
  } catch (err) {
    yield put(upcomingInternDegreesSearchError(err));
  }
}

export function* LoadInternsList({ companyId, searchParams }: IInternshipHistoryRequest) {
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'POST',
      url: `${apiConfig.coreReportingPath}/companies/insights/interns-list/${companyId}`,
      data: searchParams
    });
    const data = res.data.map((x: any) => CompanyInternshipSeasonDataModel.fromJS(x));
    yield put(internsListSearchSuccess(data));
  } catch (err) {
    yield put(internsListSearchError(err));
  }
}

export function* LoadSeasonInterns(companyId: string) {
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'GET',
      url: `${apiConfig.coreReportingPath}/companies/insights/season-interns/${companyId}`
    });
    const data = res.data.map((x: any) => CompanyInternshipSeasonDataModel.fromJS(x));
    yield put(seasonInternsSearchSuccess(data));
  } catch (err) {
    yield put(seasonInternsSearchError(err));
  }
}

export function* LoadLocationInterns(companyId: string) {
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'GET',
      url: `${apiConfig.coreReportingPath}/companies/insights/location-interns/${companyId}`
    });
    const data = res.data.map((x: any) => CompanyInternLocationsDataModel.fromJS(x));
    yield put(locationInternsSearchSuccess(data));
  } catch (err) {
    yield put(locationInternsSearchError(err));
  }
}

export function* LoadSummerToSummerRetention(companyId: string) {
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'GET',
      url: `${apiConfig.coreReportingPath}/companies/insights/summer-to-summer-retention/${companyId}`,
    });
    const data = CompanySummerRetentionDataModel.fromJS(res.data);
    yield put(summerToSummerRetentionSearchSuccess(data));
  } catch (err) {
    yield put(summerToSummerRetentionSearchError(err));
  }
}

export function* LoadAllSeasonsInternExperienceTask(companyId: string) {
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'GET',
      url: `${apiConfig.coreReportingPath}/companies/insights/all-seasons-intern-experience/${companyId}`
    });
    console.log(res.data);
    const data = res.data.map((x: any) => CompanyInternshipSeasonDataModel.fromJS(x));
    yield put(allSeasonsInternExperienceTaskSearchSuccess(data));
  } catch (err) {
    yield put(allSeasonsInternExperienceTaskSearchError(err));
  }
}

export function* LoadAllSeasonsQuestions({ companyId, searchParams }: IInternshipHistoryRequest) {
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'POST',
      url: `${apiConfig.coreReportingPath}/companies/insights/all-seasons-questions/${companyId}`,
      data: searchParams
    });
    const data = res.data.map((x: any) => CompanyInternshipSeasonDataModel.fromJS(x));
    yield put(allSeasonsQuestionsSearchSuccess(data));
  } catch (err) {
    yield put(allSeasonsQuestionsSearchError(err));
  }
}

export function* LoadLearningContracts({ companyId, searchParams }: IInternshipHistoryRequest) {
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'POST',
      url: `${apiConfig.coreReportingPath}/companies/insights/learning-contracts/${companyId}`,
      data: searchParams
    });
    const data = res.data.map((x: any) => CompanyInternshipSeasonDataModel.fromJS(x));
    yield put(learningContractsSearchSuccess(data));
  } catch (err) {
    yield put(learningContractsSearchError(err));
  }
}

export function* LoadInternshipExperience({ companyId, searchParams }: IInternshipHistoryRequest) {
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'POST',
      url: `${apiConfig.coreReportingPath}/companies/insights/internship-experience/${companyId}`,
      data: searchParams
    });
    const data = res.data.map((x: any) => CompanyInternshipSeasonDataModel.fromJS(x));
    yield put(internshipExperienceSearchSuccess(data));
  } catch (err) {
    yield put(internshipExperienceSearchError(err));
  }
}

export function* LoadEvaluationMeetings({ companyId, searchParams }: IInternshipHistoryRequest) {
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'POST',
      url: `${apiConfig.coreReportingPath}/companies/insights/evaluation-meetings/${companyId}`,
      data: searchParams
    });
    const data = res.data.map((x: any) => CompanyInternshipSeasonDataModel.fromJS(x));
    yield put(evaluationMeetingsSearchSuccess(data));
  } catch (err) {
    yield put(evaluationMeetingsSearchError(err));
  }
}

export function* watchInternshipHistoryLoad() {
  yield takeLatest(INTERNSHIP_HISTORY.LOAD, ({payload}: PayloadAction<IInternshipHistoryRequest>) => LoadInternshipHistory(payload));
}
export function* watchInternshipHistoryRefresh() {
  yield takeLatest(INTERNSHIP_HISTORY.REFRESH, ({payload}: PayloadAction<IInternshipHistoryRequest>) => LoadInternshipHistory(payload));
}

export function* watchInternDegreePoolsLoad() {
  yield takeLatest(INTERN_DEGREE_POOLS.LOAD, ({payload}: PayloadAction<IInternDegreePoolsRequest>) => LoadInternDegreePools(payload));
}
export function* watchInternDegreePoolsRefresh() {
  yield takeLatest(INTERN_DEGREE_POOLS.REFRESH, ({payload}: PayloadAction<IInternDegreePoolsRequest>) => LoadInternDegreePools(payload));
}

export function* watchHistoricalInternshipLocationsLoad() {
  yield takeLatest(HISTORICAL_INTERNSHIP_LOCATIONS.LOAD, ({payload}: PayloadAction<string>) => LoadHistoricalInternshipLocations(payload));
}
export function* watchHistoricalInternshipLocationsRefresh() {
  yield takeLatest(HISTORICAL_INTERNSHIP_LOCATIONS.REFRESH, ({payload}: PayloadAction<string>) => LoadHistoricalInternshipLocations(payload));
}

export function* watchCompanyHistoricalInternDegreesLoad() {
  yield takeLatest(COMPANY_HISTORICAL_INTERN_DEGREES.LOAD, ({payload}: PayloadAction<string>) => LoadCompanyHistoricalInternDegrees(payload));
}
export function* watchCompanyHistoricalInternDegreesRefresh() {
  yield takeLatest(COMPANY_HISTORICAL_INTERN_DEGREES.REFRESH, ({payload}: PayloadAction<string>) => LoadCompanyHistoricalInternDegrees(payload));
}

export function* watchMatchedStudentsLoad() {
  yield takeLatest(MATCHED_STUDENTS.LOAD, ({payload}: PayloadAction<string>) => LoadMatchedStudents(payload));
}
export function* watchMatchedStudentsRefresh() {
  yield takeLatest(MATCHED_STUDENTS.REFRESH, ({payload}: PayloadAction<string>) => LoadMatchedStudents(payload));
}

export function* watchUpcomingInternLocationsLoad() {
  yield takeLatest(UPCOMING_INTERN_LOCATIONS.LOAD, ({payload}: PayloadAction<string>) => LoadUpcomingInternLocations(payload));
}
export function* watchUpcomingInternLocationsRefresh() {
  yield takeLatest(UPCOMING_INTERN_LOCATIONS.REFRESH, ({payload}: PayloadAction<string>) => LoadUpcomingInternLocations(payload));
}

export function* watchUpcomingInternDegreesLoad() {
  yield takeLatest(UPCOMING_INTERN_DEGREES.LOAD, ({payload}: PayloadAction<string>) => LoadUpcomingInternDegrees(payload));
}
export function* watchUpcomingInternDegreesRefresh() {
  yield takeLatest(UPCOMING_INTERN_DEGREES.REFRESH, ({payload}: PayloadAction<string>) => LoadUpcomingInternDegrees(payload));
}

export function* watchInternsListLoad() {
  yield takeLatest(INTERNS_LIST.LOAD, ({payload}: PayloadAction<IInternshipHistoryRequest>) => LoadInternsList(payload));
}
export function* watchInternsListRefresh() {
  yield takeLatest(INTERNS_LIST.REFRESH, ({payload}: PayloadAction<IInternshipHistoryRequest>) => LoadInternsList(payload));
}

export function* watchSeasonInternsLoad() {
  yield takeLatest(SEASON_INTERNS.LOAD, ({payload}: PayloadAction<string>) => LoadSeasonInterns(payload));
}
export function* watchSeasonInternsRefresh() {
  yield takeLatest(SEASON_INTERNS.REFRESH, ({payload}: PayloadAction<string>) => LoadSeasonInterns(payload));
}

export function* watchLocationInternsLoad() {
  yield takeLatest(LOCATION_INTERNS.LOAD, ({payload}: PayloadAction<string>) => LoadLocationInterns(payload));
}
export function* watchLocationInternsRefresh() {
  yield takeLatest(LOCATION_INTERNS.REFRESH, ({payload}: PayloadAction<string>) => LoadLocationInterns(payload));
}

export function* watchSummerToSummerRetentionLoad() {
  yield takeLatest(SUMMER_TO_SUMMER_RETENTION.LOAD, ({payload}: PayloadAction<string>) => LoadSummerToSummerRetention(payload));
}
export function* watchSummerToSummerRetentionRefresh() {
  yield takeLatest(SUMMER_TO_SUMMER_RETENTION.REFRESH, ({payload}: PayloadAction<string>) => LoadSummerToSummerRetention(payload));
}

export function* watchAllSeasonsInternExperienceTaskLoad() {
  yield takeLatest(ALL_SEASONS_INTERN_EXPERIENCE_TASK.LOAD, ({payload}: PayloadAction<string>) => LoadAllSeasonsInternExperienceTask(payload));
}
export function* watchAllSeasonsInternExperienceTaskRefresh() {
  yield takeLatest(ALL_SEASONS_INTERN_EXPERIENCE_TASK.REFRESH, ({payload}: PayloadAction<string>) => LoadAllSeasonsInternExperienceTask(payload));
}

export function* watchAllSeasonsQuestionsLoad() {
  yield takeLatest(ALL_SEASONS_QUESTIONS.LOAD, ({payload}: PayloadAction<IInternshipHistoryRequest>) => LoadAllSeasonsQuestions(payload));
}
export function* watchAllSeasonsQuestionsRefresh() {
  yield takeLatest(ALL_SEASONS_QUESTIONS.REFRESH, ({payload}: PayloadAction<IInternshipHistoryRequest>) => LoadAllSeasonsQuestions(payload));
}

export function* watchLearningContractsLoad() {
  yield takeLatest(LEARNING_CONTRACTS.LOAD, ({payload}: PayloadAction<IInternshipHistoryRequest>) => LoadLearningContracts(payload));
}
export function* watchLearningContractsRefresh() {
  yield takeLatest(LEARNING_CONTRACTS.REFRESH, ({payload}: PayloadAction<IInternshipHistoryRequest>) => LoadLearningContracts(payload));
}

export function* watchInternshipExperienceLoad() {
  yield takeLatest(INTERNSHIP_EXPERIENCE.LOAD, ({payload}: PayloadAction<IInternshipHistoryRequest>) => LoadInternshipExperience(payload));
}
export function* watchInternshipExperienceRefresh() {
  yield takeLatest(INTERNSHIP_EXPERIENCE.REFRESH, ({payload}: PayloadAction<IInternshipHistoryRequest>) => LoadInternshipExperience(payload));
}

export function* watchEvaluationMeetingsLoad() {
  yield takeLatest(EVALUATION_MEETINGS.LOAD, ({payload}: PayloadAction<IInternshipHistoryRequest>) => LoadEvaluationMeetings(payload));
}
export function* watchEvaluationMeetingsRefresh() {
  yield takeLatest(EVALUATION_MEETINGS.REFRESH, ({payload}: PayloadAction<IInternshipHistoryRequest>) => LoadEvaluationMeetings(payload));
}


export default function* companyInsightsSaga() {
  yield all([
    call(watchInternshipHistoryLoad),
    call(watchInternshipHistoryRefresh),
    call(watchInternDegreePoolsLoad),
    call(watchInternDegreePoolsRefresh),
    call(watchHistoricalInternshipLocationsLoad),
    call(watchHistoricalInternshipLocationsRefresh),
    call(watchCompanyHistoricalInternDegreesLoad),
    call(watchCompanyHistoricalInternDegreesRefresh),
    call(watchMatchedStudentsLoad),
    call(watchMatchedStudentsRefresh),
    call(watchUpcomingInternLocationsLoad),
    call(watchUpcomingInternLocationsRefresh),
    call(watchUpcomingInternDegreesLoad),
    call(watchUpcomingInternDegreesRefresh),
    call(watchInternsListLoad),
    call(watchInternsListRefresh),
    call(watchSeasonInternsLoad),
    call(watchSeasonInternsRefresh),
    call(watchLocationInternsLoad),
    call(watchLocationInternsRefresh),
    call(watchSummerToSummerRetentionLoad),
    call(watchSummerToSummerRetentionRefresh),
    call(watchAllSeasonsInternExperienceTaskLoad),
    call(watchAllSeasonsInternExperienceTaskRefresh),
    call(watchAllSeasonsQuestionsLoad),
    call(watchAllSeasonsQuestionsRefresh),
    call(watchLearningContractsLoad),
    call(watchLearningContractsRefresh),
    call(watchInternshipExperienceLoad),
    call(watchInternshipExperienceRefresh),
    call(watchEvaluationMeetingsLoad),
    call(watchEvaluationMeetingsRefresh),
  ]);
}
